import * as React from 'react';
import { connect } from 'react-redux';
import * as Request from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';
import { browserHistory } from 'react-router';
import  { PapaJohnsFooter}  from './PapaJohnsFooter'; 
import { Dispatch } from 'redux'
import AddressAutoComplete from '../Components/AddressAutoComplete';

const logoUrl = Tgcc.ResolveUrl('~/images/PrimaryLogo.svg'); // Resolve the URL to the logo
const walkingIngredientsImgUrl = Tgcc.ResolveUrl('~/images/Walking_Ingredients.png');


const buttonStyle: React.CSSProperties = {
  background: 'linear-gradient(45deg, #0055a5, #003d7a)',
  color: '#ffffff',
  border: 'none',
  borderRadius: '6px',
  padding: '15px 30px',
  fontSize: '1rem',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
  ':hover': {
    transform: 'scale(1.05)', // Slightly increase size on hover
  },
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    backgroundColor: '#ffffff', // A clean white background
    width: '100%',
    maxWidth: '500px', // Slightly reduced for a more focused form
    margin: '40px auto', // More margin to the top and bottom
    borderRadius: '12px',
    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.1)', // More pronounced shadow for depth
  },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    formGroup: {
      marginBottom: '20px',
      width: '100%',
    },
    label: {
      fontSize: '0.9rem',
      color: '#333',
      marginBottom: '5px',
      fontWeight: 'bold',
      textTransform: 'uppercase', // Capitalized label for a modern look
      letterSpacing: '0.05em', // More spacing between letters
    },
    input: {
      width: '100%', // Full width inputs
      padding: '15px', // Larger padding for better touch targets
      border: '2px solid #ccc', // Slightly thicker border
      borderRadius: '6px', // Larger border-radius for modern rounded corners
      fontSize: '1rem', // Standard font size for better readability
      fontFamily: '"Open Sans", sans-serif', // Modern font family
    },
    datePicker: {
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      width: '100%',
    },
    successBtns: {
        ...buttonStyle,
        margin: '20px'
    }
  };

  
  const mapStateToProps = (state) => ({
    productSizes: state.ActiveProof?.product?.sizes || [],
    loginData: state.LoginData,
    userInfo: state.UserInfo,
    activeProof: state.ActiveProof,
    proofAndQuantitiesSubmitted: state.proofAndQuantitiesSubmitted,
});

  

interface PapaJohnsConfirmDetailsProps {
  productSizes: any[]                       // from mapStateToProps
  loginData:   Tgcc.LoginData               // “
  userInfo:    Tgcc.UserInfo                // “
  activeProof: Tgcc.Proof                   // “ (if it can be null, put `?:`)
  proofAndQuantitiesSubmitted: any          // “
  dispatch?:   Dispatch<any>                // injected automatically by connect()
}

  

class _PapaJohnsConfirmDetails extends React.Component<PapaJohnsConfirmDetailsProps, any> {

    constructor(props: PapaJohnsConfirmDetailsProps) {
        super(props);
        this.state = {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipcode: '',
            billingAddress: '',
            inHandsDate: '',
            errorMessage: '',
            billingAddress1: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingZipcode: '',
            isBillingSameAsShipping: true,
            formSubmitted: false,
        };

        this.handleShippingAddressChange = this.handleShippingAddressChange.bind(this);
        this.handleBillingAddressChange = this.handleBillingAddressChange.bind(this);
        this.handleInHandsDateChange = this.handleInHandsDateChange.bind(this);

    }

    componentDidMount() {
        this.loadActiveProofFromStorage();

        const { loginData } = this.props;
    
        if (loginData && loginData.token) {
            this.fetchUserInfoAndProceed(loginData);
        }
    }

    loadActiveProofFromStorage = () => {
        let activeProof = this.props.activeProof; // From Redux store
        if (!activeProof) {
          // If not in Redux, try to load from local storage
          const activeProofFromStorage = localStorage.getItem('activeProof');
          if (activeProofFromStorage) {
            activeProof = JSON.parse(activeProofFromStorage);
            this.props.dispatch({
              type: Tgcc.StateAction.SetActiveProof,
              payload: activeProof,
            });
          }
        }
    }

    fetchUserInfoAndProceed = (loginData) => {
        // Fetch user's address info
        Request.getUserInfo(loginData, (userInfo) => {
            this.setState({
                address1: userInfo.address || '',
                address2: userInfo.address2 || '',
                city: userInfo.city || '',
                state: userInfo.state || '',
                zipcode: userInfo.zip || ''
            });
            // Trigger any additional actions on login success, if necessary
        });
    };

    handleShippingAddressChange = (e: any) => {
        this.setState({ shippingAddress: e.target.value });
    };
    
    handleBillingAddressChange = (e: any) => {
        this.setState({ billingAddress: e.target.value });
    };
    
    handleInHandsDateChange = (e: any) => {
        this.setState({ inHandsDate: e.target.value });
    };
    
    
    handleAddressSelect = (selected) => {
        this.setState({
          address1: selected.address1,
          address2: selected.address2,
          city: selected.city,
          state: selected.state,
          zipcode: selected.zipcode,
        });
      };
      
    
      handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };

      handleBillingAddressInputChange = (e) => {
        // Correctly extract the value from the event target
        const value = e.target.value;
        this.setState({ billingAddress1: value });
    };

    toggleBillingSameAsShipping = () => {
        this.setState(prevState => ({
            isBillingSameAsShipping: !prevState.isBillingSameAsShipping,
            ...(prevState.isBillingSameAsShipping ? {} : { // Copy shipping address to billing if toggling on
                billingAddress1: prevState.address1,
                billingCity: prevState.city,
                billingState: prevState.state,
                billingZipcode: prevState.zipcode,
            })
        }));
    };
    
    renderSuccessPopup() {
        if (!this.state.formSubmitted) {
          return null;
        }
      
        return (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '10px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
              textAlign: 'center',
              maxWidth: '400px', // Smaller width for the entire popup
            }}>
              <h2>Thank You!</h2>
              <img src={walkingIngredientsImgUrl} alt="Walking Ingredients" style={{ maxWidth: '100%', height: 'auto', paddingBottom: '20px' }} />
              <p>Thank you for placing your order for Papa John's Spirit Wear! A customer service representative will be in contact with you soon to complete your order.</p>
              <p>If you have any questions or concerns, feel free to <a href="mailto:sales@grafcow.com" style={{ color: '#0000EE', textDecoration: 'underline' }}>email us</a> or call us at <a href="tel:+18004723269" style={{ color: '#0000EE', textDecoration: 'underline' }}>(800) 472-3269</a>.</p>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {/* <button
                  key="closeBtn"
                  style={{ ...styles.successBtns, width: '90%', marginBottom: '10px' }}
                  onClick={() => this.setState({ formSubmitted: false })}
                >
                  Close
                </button>                 */}
                <button key="viewAllDesignsBtn" style={{ ...styles.successBtns, width: '90%', marginBottom: '10px' }}  onClick={() => {
                  this.setState({ formSubmitted: true });
                  browserHistory.push('/papajohns/view-designs');
                }}>
                  View All Designs</button>
                <button key="addAnotherItemBtn" style={{ ...styles.successBtns, width: '90%' }} onClick={() => {
                  this.setState({ formSubmitted: true });
                  browserHistory.push('/papajohns/color-select?newOrder=true');
                  }}>Add Another Item</button>
              </div>
            </div>
          </div>
        );
      }
      handleViewDesignsClick = () => {
        // You may need to change this depending on your routing logic
        // e.g., this.props.history.push('/designs')
        window.location.href = '/designs';
      }
      
    handleSubmit = async (e) => {
        e.preventDefault();
        const { activeProof } = this.props;
        if (!activeProof) {
          this.setState({ errorMessage: 'Proof information is not available. Please try again.' });
          return;
        }

        // Constructing the shipping address object from the state
        const shippingAddress = {
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city,
            state: this.state.state,
            zipcode: this.state.zipcode,
        };
    
        // Constructing the billing address object from the state
        const billingAddress = this.state.isBillingSameAsShipping ? shippingAddress : {
            address1: this.state.billingAddress1,
            address2: this.state.billingAddress2,
            city: this.state.billingCity,
            state: this.state.billingState,
            zipcode: this.state.billingZipcode,
        };
    
        // Aggregating details for API submission
        const WebOrderId = activeProof.proofId
        const details = {
            shippingAddress,
            billingAddress,
            WebOrderId
        };
    
        // Using the API function to submit the details
        Request.submitShippingAndBillingDetails(
            this.props.loginData,
            details,
            (response) => {
                console.log("Details submitted successfully:", response);
                this.setState({ formSubmitted: true });
            },
            (error) => {
                console.error("Failed to submit details:", error);
                this.setState({ errorMessage: 'Failed to submit details. Please try again.' });
            }
        );
    };

    handleAddressInputChange = (value) => {
        // Update the state with the new address value
        this.setState({ address1: value });
    };

      render() {
        
        return (
        <div>
        {this.renderSuccessPopup()}
        <div style={styles.container}>
            <h1 style={{ textAlign: 'center' }}>Confirm Your Details</h1>
            <img src={logoUrl} alt="Company Logo" style={{ maxWidth: '200px', margin: '20px auto' }} />
            <form onSubmit={this.handleSubmit}>

            {/* Shipping Address */}
            <h2 style={{ color: '#0055a5' }}>Shipping Address</h2>
            <div style={{ ...styles.formGroup, marginTop: '20px' }}>
                <label style={styles.label} htmlFor="address1">Address Line 1</label>
                <AddressAutoComplete
                    placeholder="Enter address"
                    inputStyle={styles.input}
                    className="pj-input"
                    addressValue={this.state.address1}
                    onAddressSelect={(selected) => this.handleAddressSelect(selected)}
                    onInputChange={this.handleAddressInputChange}
                />
            </div>

            <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="address2">Address Line 2</label>
                <input
                style={styles.input}
                className="pj-input"
                id="address2"
                name="address2"
                value={this.state.address2}
                onChange={this.handleInputChange}
                placeholder="Apartment, suite, etc. (optional)"
                />
            </div>

            <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="city">City</label>
                <input
                style={styles.input}
                className="pj-input"
                id="city"
                name="city"
                value={this.state.city}
                onChange={this.handleInputChange}
                />
            </div>

            <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="state">State</label>
                <input
                style={styles.input}
                className="pj-input"
                id="state"
                name="state"
                value={this.state.state}
                onChange={this.handleInputChange}
                />
            </div>

            <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="zipcode">Zipcode</label>
                <input
                style={styles.input}
                className="pj-input"
                id="zipcode"
                name="zipcode"
                value={this.state.zipcode}
                onChange={this.handleInputChange}
                />
            </div>

            {/* Billing Address */}
            <h2 style={{ color: '#0055a5', marginTop: '20px' }}>Billing Address</h2>
            <div style={styles.formGroup}>
                <label>
                <input
                    type="checkbox"
                    checked={this.state.isBillingSameAsShipping}
                    onChange={this.toggleBillingSameAsShipping}
                /> Is billing address the same as shipping?
                </label>
            </div>

            {!this.state.isBillingSameAsShipping && (
            <div>
                <div style={styles.formGroup}>
                    <label style={styles.label} htmlFor="billingAddress1">Address Line 1</label>
                    {/* Use AddressAutoComplete for billingAddress1 when billing is not the same as shipping */}
                    <AddressAutoComplete
                        placeholder="Enter billing address"
                        inputStyle={styles.input}
                        className="pj-input"
                        addressValue={this.state.billingAddress1}
                        onAddressSelect={(selected) => {
                            // Update the billing address based on selection
                            this.setState({
                                billingAddress1: selected.address1,
                                billingCity: selected.city,
                                billingState: selected.state,
                                billingZipcode: selected.zipcode,
                            });
                        }}
                        onInputChange={(value) => this.setState({ billingAddress1: value })}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label} htmlFor="billingAddress2">Address Line 2</label>
                    <input
                    style={styles.input}
                    className="pj-input"
                    id="billingAddress2"
                    name="billingAddress2"
                    value={this.state.billingAddress2}
                    onChange={this.handleInputChange}
                    placeholder="Apartment, suite, etc. (optional)"
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label} htmlFor="billingCity">City</label>
                    <input
                    style={styles.input}
                    className="pj-input"
                    id="billingCity"
                    name="billingCity"
                    value={this.state.billingCity}
                    onChange={this.handleInputChange}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label} htmlFor="billingState">State</label>
                    <input
                    style={styles.input}
                    className="pj-input"
                    id="billingState"
                    name="billingState"
                    value={this.state.billingState}
                    onChange={this.handleInputChange}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label} htmlFor="billingZipcode">Zipcode</label>
                    <input
                    style={styles.input}
                    className="pj-input"
                    id="billingZipcode"
                    name="billingZipcode"
                    value={this.state.billingZipcode}
                    onChange={this.handleInputChange}
                    />
                </div>
            </div>
            )}

            {this.state.errorMessage && <div style={{ color: 'red' }}>{this.state.errorMessage}</div>}
            <button style={buttonStyle} type="submit">Submit</button>
            </form>
        </div>
        <PapaJohnsFooter/>
        </div>
        );

    }
}

export const PapaJohnsConfirmDetails =
  connect(mapStateToProps)(Radium(_PapaJohnsConfirmDetails))